module.exports = __webpack_public_path__ + "media/images/site/ellipse-right-21020192cf3d3ed2e6d68cf5a64623b0.svg";